<template>
    <div class="block-container highlights-block">
        <div class="highlights-col">
            <div class="highlights-row carousel-heading">
                <h2 class="block-heading">Highlights</h2>
                <div class="highlights-pagination">
                    <button class="highlights-pagination-button" aria-label="Previous Card"
                        @click="goTo(current - 1)">&#8249;</button>
                    <p>{{ current + 1 }} / {{ cards.length }}</p>
                    <button class="highlights-pagination-button" aria-label="Next Card"
                        @click="goTo(current + 1)">&#8250;</button>
                </div>
            </div>
            <div class="highlights-carousel" ref="carouselRef">

                <div class="highlights-row">
                    <div v-for="(card, index) in carouselCards" :key="index" class="highlights-cards-container">
                        <div class="highlights-card" :style="{
                            borderTop: '10px solid',
                            borderTopColor: (() => {
                                switch (index % cards.length) {
                                    case 0: return '#D44420';
                                    case 1: return '#ffb500';
                                    case 2: return '#72c5e7';
                                    default: return '#01426A';
                                }
                            })()
                        }">
                            <img :src="card.image" :alt="card.title" class="highlights-card-image" />
                            <div class="text-container">
                                <p>{{ card.category }}</p>
                                <a :href="card.link">{{ card.title }}</a>
                            </div>
                        </div>
                    </div>

                </div>
                <div class="pagination-dots">
                    <button v-for="(card, index) in cards" :key="index" class="pagination-dot"
                        :class="{ active: current === index }" @click="goTo(index)"
                        :aria-label="`Go to Card ${index + 1}`">
                    </button>
                </div>
                <a class="bottom-link" href="https://www.macalester.edu/news/">Explore more Macalester News
                    &#8250;
                </a>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "MobileCarousel",
    props: {
        cards: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            current: 0,
        }
    },
    computed: {
        carouselCards() {
            return [...this.cards, this.cards[0]];
        }
    },
    methods: {
        goTo(index) {
            const row = this.$refs.carouselRef.querySelector('.highlights-row');
            const cardWidth = row.offsetWidth;

            if (index >= this.cards.length) {
                // Smooth scroll forward to the clone of the first card
                // After the animation, snap silently to the real first card
                setTimeout(() => {
                    this.current = 0;
                    row.scrollTo({ left: 0, behavior: 'smooth' });
                }, 0);
            } else if (index < 0) {
                this.current = this.cards.length - 1;
                row.scrollTo({ left: cardWidth * this.current, behavior: 'smooth' });
            } else {
                this.current = index;
                row.scrollTo({ left: cardWidth * this.current, behavior: 'smooth' });
            }
        },
    },
    mounted() {
        this.current = 0;
    },
}
</script>
<style scoped lang="scss">
@import "~@/scss/abstracts/functions";
@import "~@/scss/abstracts/lookups";

button.pagination-dot.active {
    background-color: #d44420 !important;
}

.carousel-heading {
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    h2 {
        margin: 0;
    }
}

.highlights-pagination p {
    margin: 0 10px;
    color: #01426A;
    font-size: rem(16);
}

.highlights-carousel {
    overflow: hidden !important;
    width: 100%;

    .highlights-row {
        flex-wrap: nowrap;
        overflow-x: scroll;
        scroll-snap-type: x mandatory;
        -webkit-overflow-scrolling: touch;
        gap: 0;

    }

    .highlights-cards-container {
        flex: 0 0 100%;
        scroll-snap-align: start;
        min-width: 100%;
        scroll-snap-align: start;
        flex-direction: row;
        padding: 10px;
    }

    .bottom-link {
        display: block;
        text-align: right;
        font-weight: bold;
        margin-top: 12px;
        padding-right: 10px; 
    }
}


.highlights-pagination-button {
    background-color: color(blue);
    color: white;
    border: none;
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: rem(24);
    transition: background-color 0.3s ease;

    &:hover {
        background-color: color(blue-light);
        cursor: pointer;
    }
}

.pagination-dots {
    .pagination-dot {
        background-color: #A5ADAF;
        border: none;
        border-radius: 50%;
        margin: 10px 0;
        padding: 0;
        height: 15px;
        width: 15px;
    }

    justify-content: center;
    gap: 10px;
    display: flex;
}
</style>



// WEBPACK FOOTER //
// src/js/components/MobileCarousel.vue